import React from "react";
import Download from "../img/icon_download.png";
import { useTranslation } from "react-i18next";
import "./SaveButton.scss";

function SaveButton({ link }) {
  const { t } = useTranslation();
  return (
    <div className="saveButton">
      <button
        className="saveButton__button"
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        <span>{t("save_pdf")}</span>
        <img src={Download} alt="" />
      </button>
    </div>
  );
}

export default SaveButton;
